const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'crawlertest',
  tiles: {
    blocker: 0,
    brick_dark0: 1,
    brick_dark3: 2,
    cobble_blood1: 3,
    dngn_closed_door: 4,
    dngn_locked_door: 5,
    dngn_open_door: 6,
    grey_dirt0: 7
  },
  uidata: {
    rects: [
      vec4(8/512,8/64,40/512,40/64),
      vec4(56/512,8/64,88/512,40/64),
      vec4(104/512,8/64,136/512,40/64),
      vec4(152/512,8/64,184/512,40/64),
      vec4(200/512,8/64,232/512,40/64),
      vec4(248/512,8/64,280/512,40/64),
      vec4(296/512,8/64,328/512,40/64),
      vec4(344/512,8/64,376/512,40/64)
    ]
  },
  FRAME_BLOCKER: 0,
  FRAME_BRICK_DARK0: 1,
  FRAME_BRICK_DARK3: 2,
  FRAME_COBBLE_BLOOD1: 3,
  FRAME_DNGN_CLOSED_DOOR: 4,
  FRAME_DNGN_LOCKED_DOOR: 5,
  FRAME_DNGN_OPEN_DOOR: 6,
  FRAME_GREY_DIRT0: 7
};
spritesheetRegister(module.exports);
